import { Routes, RouterModule } from '@angular/router';

import { DomainsComponent } from './domains/domains.component';
import { DomainsModalComponent } from './domains/domains-modal/domains-modal.component';
import { DiagnosisComponent } from './diagnosis/diagnosis.component';
import { DiagnosisModalComponent } from './diagnosis/diagnosis-modal/diagnosis-modal.component';
import { SelfReportSettingComponent } from './self-report-setting.component';
import { SymptomsComponent } from './symptoms/symptoms.component';
import { SymptomsModalComponent } from './symptoms/symptoms-modal/symptoms-modal.component';
import { SelfReportsComponent } from './self-report/self-reports.component';
import { SelfReportsModalComponent } from './self-report/self-reports-modal/self-reports-modal.component';
import { SrConfigurationModalComponent } from './self-report/sr-configuration-modal/sr-configuration-modal.component';
import { LifeCircumstancesComponent } from './life-circumstance/life-circumstances.component';

export const SelfReportSettingRoutesModule = RouterModule.forChild( [
        {
            path: '',
            component: SelfReportSettingComponent,
            redirectTo: 'domains',
            pathMatch: 'full',
            data: {
                // breadcrumb: 'SelfReportSetting-Center',
                // breadcrumbSpecific: 'SelfReportSetting-Center',
            }
        },
        {
            path: 'domains',
            component: DomainsComponent,
            data: {
                breadcrumb: 'Domains Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'domains/create', component: DomainsModalComponent
        },
        {
            path: 'domains/edit/:id', component: DomainsModalComponent
        },
        {
            path: 'feelings',
            component: SymptomsComponent,
            data: {
                breadcrumb: 'Symptoms Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'feelings/create', component: SymptomsModalComponent
        },
        {
            path: 'feelings/edit/:id', component: SymptomsModalComponent
        },
        {
            path: 'diagnosis',
            component: DiagnosisComponent,
            data: {
                breadcrumb: 'Diagnosis Management',
            }
        },
        {
            path: 'self-report',
            component: SelfReportsComponent,
            data: {
                breadcrumb: 'Self Reports Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'diagnosis/create', component: DiagnosisModalComponent
        },
        {
            path: 'diagnosis/edit/:id', component: DiagnosisModalComponent
        },
        {
            path: 'self-report/create', component: SelfReportsModalComponent
        },
        {
            path: 'self-report/edit/:id', component: SelfReportsModalComponent
        },
        {
            path: 'self-report/configuration', component: SrConfigurationModalComponent
        },
        {
            path: 'self-report/configuration/:id', component: SrConfigurationModalComponent
        },
        {
            path: 'self-report/group-selection', component: SrConfigurationModalComponent
        },
        {
            path: 'self-report/group-selection/:id', component: SrConfigurationModalComponent
        },
        {
            path: 'life-circumstances',
            component: LifeCircumstancesComponent,
            data: {
                breadcrumb: 'Life circumstances Management',
                breadcrumbSpecific: '',
            }
        },
        {
            path: 'life-circumstances/create', component: LifeCircumstancesComponent
        },
        {
            path: 'life-circumstances/edit/:id', component: LifeCircumstancesComponent
        },
    ]
);
